.accordionItem_expanded {
  pointer-events: none;
}

.backButton a:focus-visible > div {
  border-bottom: 2px solid var(--colors-primary-main);
}

.checkoutHeader {
  box-shadow: var(--shadows-divider);
  width: 100%;
  height: 48px;
  display: grid;
  grid-template-columns: 1fr minmax(max-content, 1fr) 1fr;
  column-gap: 8px;

  @media (--reefer-media-desktop-sm-min) {
    height: 80px;
  }
}

.checkoutHeader_bloom {
  height: 40px;

  @media (--reefer-media-desktop-sm-min) {
    height: 40px;
  }
}

.noWrapLink {
  white-space: nowrap;
  pointer-events: auto;
}

.paymentsCard {
  background: var(--colors-grays-ultralight);
  border-radius: var(--border-radius-lg);
}

.paymentsCard :global(.reefer_fieldWrapper_labelContainer) > div:first-child,
.paymentsCard
  :global(.reefer_fieldWrapper_labelContainer)
  > div:first-child
  > label {
  width: 100%;
}
